import React from "react";
import IconsLingo from "../IconsLingo/iconsLingo";
import imgDown from "../../assets/images/icons/icon_cs_down.png";
import imgUp from "../../assets/images/icons/icon_cs_up.png";

const MenuItemLingo = ({
  icon,
  name,
  isSelected,
  clickAction = () => {},
  hasNotification = false,
  iconSettings = false,
  open,
}) => {
  const fillSelected = isSelected ? "var(--color-blue)" : "var(--color-black)";
  const divSelected = isSelected
    ? { borderLeftColor: "var(--color-blue)", borderLeftWidth: "4px", borderStyle: "solid" }
    : {};

  const notificationIcon = hasNotification ? "unReadNotification" : "";

  return (
    <button
      className={`side-menu-item ${iconSettings && "dropMenuButton"}`}
      style={divSelected}
      onClick={(e) => clickAction(e)}
      autoFocus={isSelected}
    >
      <IconsLingo name={icon} fill={fillSelected} />
      <span style={{ color: fillSelected }}>{name}</span>
      {hasNotification > 0 && (
        <div className={notificationIcon}> {hasNotification >= 1000 ? "999+" : hasNotification}</div>
      )}
      {iconSettings && <img src={open ? imgUp : imgDown} alt="iconmenu" />}
    </button>
  );
};

export default MenuItemLingo;
